import { useAuth0 as e } from "@auth0/auth0-react";
import { AppError as t, AuthorizationError as n, CollaboratorInvitation as r, CollaboratorTeamMember as i, DomainTakkenLicense as a, DomainUsage as o, DomainVegaLicenses as s, ERROR_CODE as c, MemberApplicant as l, NetworkError as u, OperationHistoryFacets as d, OperationHistoryPage as f, OperationHistorySettings as p, ParsableDate as m, Plan as h, PlanSummary as g, ProviderUser as _, ProviderUserBlockSources as v, ProviderUserLockout as y, ReadAdminCustomerProfile as b, ReadCustomer as x, ReadCustomerContracts as S, ReadCustomerProfile as C, ReadDomain as w, ReadDomainMfaState as ee, ReadDomainUserAuthenticationMethods as te, ReadInvitation as ne, ReadOrganization as T, ReadPolicy as re, ReadProviderUserAuthenticationMethods as ie, ReadRole as E, ReadSubscription as ae, ReadUser as D, ensureError as O } from "esa-core";
import { createContext as k, useCallback as A, useContext as oe, useEffect as se, useMemo as j, useRef as M, useState as N } from "react";
import { jsx as P } from "@emotion/react/jsx-runtime";
import ce, { default as le } from "swr";
import ue from "swr/infinite";
import { z as F } from "zod";
export * from "swr";
//#region lib/services/ApiClient.ts
var I = class extends t {
	response;
	apiErrorCode;
	status;
	constructor(e, t) {
		let { status: n } = e, { url: r } = e, i = c.APPLICATION_ERROR;
		n >= 500 ? i = c.SERVER_ERROR : n === 404 ? i = c.NOT_FOUND_ERROR : n >= 400 && (i = c.CLIENT_ERROR), super("HttpError", {
			url: r,
			status: n,
			response: e
		}, void 0, i), this.response = e, this.apiErrorCode = t, this.name = new.target.name, this.status = n;
	}
}, L = "https://a.com", R = class {
	baseUrl;
	getAccessToken;
	customHeaders;
	constructor(e, t, n) {
		this.baseUrl = e, this.getAccessToken = t, this.customHeaders = n;
	}
	async composeHeaders(e) {
		e?.method === void 0 && (e.method = "GET"), e.headers = {
			...e?.headers,
			...this.customHeaders
		}, this.getAccessToken && (e.headers = {
			Authorization: `Bearer ${await this.getAccessToken()}`,
			...e?.headers
		});
	}
	async request(e, n = {}) {
		let r = new URL(e, L).href.replace(L, this.baseUrl);
		await this.composeHeaders(n);
		let i = await fetch(r, n).catch((e) => {
			throw new u({ url: r }, O(e));
		});
		if (!i.ok) throw new I(i, (await i.json().catch((e) => {
			throw new t("Failed to parse Error response", { ur: i.url }, O(e));
		})).errorCode);
		return i;
	}
	async requestJsonResponse(e, n) {
		let r = await this.request(e, n);
		try {
			return await r.json();
		} catch (e) {
			throw new t("Failed to parse GET response", { ur: r.url }, O(e));
		}
	}
	get({ path: e }) {
		return this.requestJsonResponse(e, { method: "GET" });
	}
	getCsv({ path: e }) {
		return this.request(e, { method: "GET" }).then((e) => e.blob()).then((e) => ({ url: window.URL.createObjectURL(e) }));
	}
	put({ path: e, body: t }) {
		return this.requestJsonResponse(e, {
			method: "PUT",
			headers: { "Content-Type": "application/json" },
			body: t
		});
	}
	post({ path: e, body: t }) {
		return this.requestJsonResponse(e, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: t
		});
	}
	delete({ path: e }) {
		return this.requestJsonResponse(e, { method: "DELETE" });
	}
}, z = ({ baseUrl: t, audience: r, scope: i, customHeaders: a }) => {
	let { error: o, getAccessTokenSilently: s, getAccessTokenWithPopup: c, isLoading: l } = e(), u = j(() => new R(t ?? r, async () => {
		let e = await s({ authorizationParams: {
			audience: r,
			scope: i
		} }).catch(async (e) => {
			if (e?.error === "consent_required") return c({ authorizationParams: {
				audience: r,
				scope: i
			} }).catch((e) => {
				throw new n({ reason: "Failed to get access token" }, O(e));
			});
			throw new n({ reason: "Failed to get access token" }, O(e));
		});
		if (e == null) throw new n({ reason: "Failed to get access token(token is empty)" });
		return e;
	}, a), [
		r,
		t,
		s,
		c,
		i,
		a
	]);
	return l ? {
		isLoading: !0,
		error: null,
		apiClient: null
	} : o ? {
		isLoading: !1,
		error: o,
		apiClient: null
	} : {
		isLoading: !1,
		error: null,
		apiClient: u
	};
}, de = (e) => {
	let t = M(e), n = M(void 0), r = M(!1), i = M(!1), [, a] = N(0);
	return r.current && (i.current = !0), se(() => (r.current ||= (n.current = t.current(), !0), a(1), () => {
		i.current && n.current && n.current();
	}), []), { refresh: () => {
		n.current && n.current(), n.current = t.current();
	} };
}, fe = ({ initial: e } = { initial: !1 }) => {
	let [t, n] = N(e);
	return [
		t,
		A(() => {
			n(!0);
		}, [n]),
		A(() => {
			n(!1);
		}, [n])
	];
}, pe = () => {
	let [e, t] = N(null), n = A((e) => {
		t(e);
	}, [t]), r = A(() => {
		t(null);
	}, [t]);
	return e === null ? {
		open: !1,
		entity: null,
		openDialog: n,
		onClose: r
	} : {
		open: !0,
		entity: e,
		openDialog: n,
		onClose: r
	};
}, me = ({ filter: e, ...t }) => {
	let [{ page: n, perPage: r, params: i }, a] = N({
		page: 0,
		perPage: 10,
		...t
	}), o = A((e) => a((t) => ({
		...t,
		page: e
	})), [a]), s = A((e) => a((t) => ({
		...t,
		perPage: e,
		page: 0
	})), [a]), c = A((e) => a((t) => ({
		...t,
		params: e,
		page: 0
	})), [a]), l = j(() => n * r, [n, r]);
	return {
		setPage: o,
		setPerPage: s,
		setParams: c,
		applyFilter: A((t) => {
			let a = e(t, i);
			return a.length <= l ? {
				items: a.slice(0, r),
				count: a.length,
				page: 0,
				perPage: r
			} : {
				items: a.slice(l, l + r),
				count: a.length,
				page: n,
				perPage: r
			};
		}, [
			e,
			i,
			l,
			n,
			r
		])
	};
}, he = ({ filter: e, ...t }) => {
	let [{ params: n }, r] = N({ ...t });
	return {
		params: n,
		setParams: A((e) => r((t) => ({
			...t,
			params: e,
			page: 0
		})), [r]),
		applyFilter: A((t) => e(t, n), [e, n])
	};
}, ge = (e) => Array.isArray(e), B = (e, t) => {
	if (e == null || e === "") return !1;
	if (ge(e)) for (let n = 0; n < e.length; n += 1) {
		let r = e[n];
		if (B(r, t)) return !0;
	}
	else if (typeof e == "object") {
		let n = Object.values(e);
		for (let e = 0; e < n.length; e += 1) {
			let r = n[e];
			if (B(r, t)) return !0;
		}
	}
	return t(e);
}, _e = (e, t) => !t || t.value == null ? e : e.filter((e) => B(e, (e) => typeof e == "string" && e.includes(t.value))), ve = () => {
	let [e, t] = N({
		open: !1,
		anchorEl: null
	}), n = A((e) => t({
		open: !0,
		anchorEl: e.currentTarget
	}), [t]), r = A(() => t({
		open: !1,
		anchorEl: null
	}), [t]), i = A((e) => {
		t(e === null ? {
			open: !1,
			anchorEl: null
		} : {
			open: !0,
			anchorEl: e
		});
	}, [t]);
	return {
		...e,
		openMenu: i,
		closeMenu: r,
		handleClick: n
	};
}, ye = (e, t) => e.isLoading ? {
	isLoading: !0,
	error: null,
	domainVegaLicenses: null
} : e.error ? {
	isLoading: !1,
	error: e.error,
	domainVegaLicenses: null
} : e.domain.ebone?.customerId == null ? {
	isLoading: !1,
	error: null,
	domainVegaLicenses: null
} : t.isLoading ? {
	isLoading: !0,
	error: null,
	domainVegaLicenses: null
} : t.error ? {
	isLoading: !1,
	error: t.error,
	domainVegaLicenses: null
} : {
	isLoading: !1,
	error: null,
	domainVegaLicenses: t.model
}, V = k(null), be = ({ children: e, baseUrl: t, audience: n, customHeaders: r }) => {
	let i = j(() => ({
		baseUrl: t,
		audience: n,
		customHeaders: r
	}), [
		t,
		n,
		r
	]);
	return /* @__PURE__ */ P(V.Provider, {
		value: i,
		children: e
	});
}, H = () => {
	let e = oe(V);
	if (!e) throw new t("useEsaApiContext must be called inside `<EsaApiProvider>`", {});
	return e;
}, U = k(null), xe = ({ children: e, baseUrl: t, audience: n, customHeaders: r }) => {
	let i = j(() => ({
		baseUrl: t,
		audience: n,
		customHeaders: r
	}), [
		t,
		n,
		r
	]);
	return /* @__PURE__ */ P(U.Provider, {
		value: i,
		children: e
	});
}, W = () => {
	let e = oe(U);
	if (!e) throw new t("useOneApiContext must be called inside `<OneApiContext>`", {});
	return e;
}, G = ({ api: { audience: e, baseUrl: n, path: r, customHeaders: i }, schema: a, config: o }) => {
	let { isLoading: s, apiClient: c, error: l } = z({
		audience: e,
		baseUrl: n,
		customHeaders: i
	}), { data: u, error: d, mutate: f, isValidating: p } = le(s || l ? null : r, (e) => {
		if (l) throw l;
		if (!c) throw new t("Unreachable code", { path: e });
		return c.get({ path: e });
	}, o);
	if (d != null) return {
		isLoading: !1,
		error: O(d),
		model: null,
		mutate: f,
		isValidating: p
	};
	if (u == null) return {
		isLoading: !0,
		error: null,
		model: null,
		mutate: f,
		isValidating: p
	};
	let m = a.safeParse(u);
	return m.success ? {
		isLoading: !1,
		error: null,
		model: m.data,
		mutate: f,
		isValidating: p
	} : {
		isLoading: !1,
		error: m.error,
		model: null,
		mutate: f,
		isValidating: p
	};
}, K = ({ api: { path: e }, schema: t, config: n }) => {
	let { audience: r, baseUrl: i, customHeaders: a } = H(), o = G({
		api: {
			audience: r,
			baseUrl: i,
			path: e,
			customHeaders: a
		},
		schema: t,
		config: n
	});
	return j(() => o, [o]);
}, q = ({ domainUid: e }) => {
	let { isLoading: t, error: n, model: r, mutate: i } = K({
		api: { path: `/domains/${e}` },
		schema: w
	});
	return t ? {
		isLoading: t,
		error: null,
		domain: null,
		mutate: i
	} : n ? {
		isLoading: !1,
		error: n,
		domain: null,
		mutate: i
	} : {
		isLoading: !1,
		error: null,
		domain: r,
		mutate: i
	};
}, Se = ({ domainUid: e }) => {
	let t = q({ domainUid: e });
	return ye(t, K({
		api: { path: t.domain?.ebone?.customerId == null ? null : `/domains/${e}/licenses` },
		schema: s
	}));
}, Ce = (e) => {
	let t = e.filter((e) => e.licenseName === "fcCustomizeBasic" && (e.licenseAttributeMap.fcName ?? "") !== "");
	if (t.length === 0) return null;
	let n = t.sort((e, t) => e.licenseAttributeMap.fcName.localeCompare(t.licenseAttributeMap.fcName, "ja"))[0], r = n.licenseAttributeMap.pcLogo ?? "", i = n.licenseAttributeMap.smpLogo ?? "";
	return {
		fcName: n.licenseAttributeMap.fcName,
		pcLogo: r === "" ? i : r,
		smpLogo: i === "" ? r : i
	};
}, we = ({ domainUid: e }) => {
	let t = Se({ domainUid: e }), n = j(() => t.domainVegaLicenses && Ce(t.domainVegaLicenses.licenses), [t.domainVegaLicenses]);
	return t.isLoading ? {
		isLoading: !0,
		error: null,
		fcLicense: null
	} : t.error ? {
		isLoading: !1,
		error: t.error,
		fcLicense: null
	} : t.domainVegaLicenses === null ? {
		isLoading: !1,
		error: null,
		fcLicense: null
	} : {
		isLoading: !1,
		error: null,
		fcLicense: n
	};
}, J = (e, t) => e[0].items.length === 0 || e[e.length - 1].items.length < t, Te = (e) => {
	let t = [];
	return e.forEach((e) => {
		t = [...t, ...e.items];
	}), t;
}, Ee = 50, Y = ({ api: { audience: e, baseUrl: n, path: r, customHeaders: i, query: a }, schema: o, startIndex: s = 1, itemsPerPage: c = Ee, initialSize: l = 1, lazyLoad: u = !0, allFetch: d = !0, shouldFetch: f = !0 }) => {
	let { isLoading: p, apiClient: m, error: h } = z({
		audience: e,
		baseUrl: n,
		customHeaders: i
	}), { data: g, error: _, mutate: v, isValidating: y, size: b, setSize: x } = ue((e, t) => !f || p || t != null && (t.items == null || t.items.length === 0) ? null : `${r}?startIndex=${s + e * c}&itemsPerPage=${c}${a ?? ""}`, (e) => {
		if (h) throw h;
		if (!m) throw new t("Unreachable code", { path: e });
		return m.get({ path: e });
	}, { initialSize: l }), S = F.array(F.object({ items: o.array() }));
	if (se(() => {
		if (d) {
			let e = S.safeParse(g);
			e.success && _ == null && (J(e.data, c) || x(e.data.length + 1));
		}
	}, [
		_,
		S,
		x,
		g,
		c,
		o,
		d
	]), !f) return {
		isLoading: !1,
		error: null,
		models: [],
		mutate: v,
		isValidating: y,
		size: b,
		setSize: x
	};
	if (_ != null) return {
		isLoading: !1,
		error: O(_),
		models: null,
		mutate: v,
		isValidating: y,
		size: b,
		setSize: x
	};
	if (!g) return {
		isLoading: !0,
		error: null,
		models: null,
		mutate: v,
		isValidating: y,
		size: b,
		setSize: x
	};
	let C = S.safeParse(g);
	return C.success ? !u && !J(C.data, c) ? {
		isLoading: !0,
		error: null,
		models: null,
		mutate: v,
		isValidating: y,
		size: b,
		setSize: x
	} : {
		isLoading: !1,
		error: null,
		models: Te(C.data),
		mutate: v,
		isValidating: y,
		size: b,
		setSize: x
	} : {
		isLoading: !1,
		error: C.error,
		models: null,
		mutate: v,
		isValidating: y,
		size: b,
		setSize: x
	};
}, X = ({ api: { path: e, query: t }, schema: n, startIndex: r, itemsPerPage: i, initialSize: a, lazyLoad: o, allFetch: s, shouldFetch: c }) => {
	let { audience: l, baseUrl: u, customHeaders: d } = H(), f = Y({
		api: {
			audience: l,
			baseUrl: u,
			path: e,
			query: t,
			customHeaders: d
		},
		schema: n,
		startIndex: r,
		itemsPerPage: i,
		initialSize: a,
		lazyLoad: o,
		allFetch: s,
		shouldFetch: c
	});
	return j(() => f, [f]);
}, De = (e) => {
	let { domainUid: t } = e, n = X({
		api: { path: `/domains/${t}/invitations` },
		schema: ne,
		...e
	});
	return n.isLoading ? {
		...n,
		invitations: n.models
	} : n.error ? e.isAdmin ? {
		...n,
		invitations: n.models
	} : {
		...n,
		isLoading: !1,
		error: null,
		invitations: []
	} : {
		...n,
		invitations: n.models
	};
}, Oe = F.object({
	domainUid: F.string(),
	content: F.string(),
	registrantEmail: F.string(),
	modifiedAt: m
}), ke = F.object({ memo: Oe.nullish() }).transform(({ memo: e }) => e == null ? { status: "none" } : {
	status: "registered",
	...e
}), Ae = ({ domainUid: e, canRead: t }) => {
	let { isLoading: n, error: r, model: i, mutate: a } = K({
		api: { path: t ? `/domains/${e}/memo` : null },
		schema: ke
	});
	return t ? n ? {
		status: "loading",
		mutate: a
	} : r ? {
		status: "error",
		error: r,
		mutate: a
	} : {
		status: "loaded",
		memo: i,
		mutate: a
	} : {
		status: "unauthorized",
		mutate: a
	};
}, je = (e) => {
	let { domainUid: t } = e, n = X({
		api: { path: `/domains/${t}/member_applicants` },
		schema: l,
		...e
	});
	return n.isLoading ? {
		...n,
		memberApplicants: n.models
	} : n.error ? e.isAdmin ? {
		...n,
		memberApplicants: n.models
	} : {
		...n,
		isLoading: !1,
		error: null,
		memberApplicants: []
	} : {
		...n,
		memberApplicants: n.models
	};
}, Me = (e) => {
	let { domainUid: t } = e, n = X({
		api: { path: `/domains/${t}/organizations` },
		schema: T,
		...e
	});
	if (n.isLoading || n.error) return {
		...n,
		organizations: n.models,
		organizationUids: null
	};
	let r = new Map(n.models.map((e) => [e.organizationUid, e])), i = n.models.map(({ name: e, organizationUid: t }) => ({
		name: e,
		organizationUid: t
	})), a = n.models.map(({ organizationUid: e }) => e), o = (e) => e == null ? "" : r.get(e)?.name ?? "";
	return {
		...n,
		organizations: n.models,
		organizationUids: a,
		organizationMap: r,
		organizationOptions: i,
		getOrganizationName: o
	};
}, Z = ({ planType: e }) => `&type=${e}`, Ne = (e) => {
	let { domainUid: t } = e, n = X({
		api: {
			path: `/domains/${t}/plans`,
			query: Z(e)
		},
		schema: h,
		...e
	});
	return n.isLoading || n.error, {
		...n,
		plans: n.models
	};
}, Pe = (e) => {
	let { domainUid: t } = e, n = X({
		api: {
			path: `/domains/${t}/plan_summaries`,
			query: Z(e)
		},
		schema: g,
		...e
	});
	return n.isLoading || n.error, {
		...n,
		plans: n.models
	};
}, Fe = (e) => {
	let { domainUid: t } = e, n = X({
		api: { path: `/domains/${t}/roles` },
		schema: E,
		...e
	});
	if (n.isLoading || n.error) return {
		...n,
		roles: n.models
	};
	let r = new Map(n.models.map((e) => [e.roleUid, e])), i = n.models.map(({ name: e, roleUid: t }) => ({
		name: e,
		roleUid: t
	})), a = n.models.map(({ roleUid: e }) => e), o = (e) => e == null ? "" : r.get(e)?.name ?? "";
	return {
		...n,
		roles: n.models,
		roleUids: a,
		roleOptions: i,
		getRoleName: o
	};
}, Ie = F.object({
	supportAccountProhibitionUid: F.string(),
	domainUid: F.string(),
	registrantEmail: F.string(),
	reason: F.string(),
	modifiedAt: m
}), Le = F.object({ supportAccountProhibition: Ie.nullish() }).transform(({ supportAccountProhibition: e }) => e == null ? { status: "none" } : {
	status: "registered",
	...e
}), Re = ({ domainUid: e, canRead: t = !0 }) => {
	let { isLoading: n, error: r, model: i, mutate: a } = K({
		api: { path: t ? `/domains/${e}/support_account_prohibition` : null },
		schema: Le
	});
	return t ? n ? {
		status: "loading",
		mutate: a
	} : r ? {
		status: "error",
		error: r,
		mutate: a
	} : {
		status: "loaded",
		prohibition: i,
		mutate: a
	} : {
		status: "unauthorized",
		mutate: a
	};
}, ze = F.object({
	supportAccountReasonUid: F.string(),
	domainUid: F.string(),
	registrantEmail: F.string(),
	approver: F.string(),
	approvedOn: m,
	approvalReason: F.string()
}), Be = (e, t) => e ? {
	type: "only",
	uids: t
} : { type: "all" }, Ve = ze.extend({
	closedAt: m.nullish(),
	restrictsOrganizations: F.boolean(),
	allowedOrganizationUids: F.array(F.string()),
	restrictsRoles: F.boolean(),
	allowedRoleUids: F.array(F.string())
}).transform(({ closedAt: e, restrictsOrganizations: t, allowedOrganizationUids: n, restrictsRoles: r, allowedRoleUids: i, ...a }) => {
	let o = {
		...a,
		organizationRestriction: Be(t, n),
		roleRestriction: Be(r, i)
	};
	return e == null ? {
		...o,
		status: "open"
	} : {
		...o,
		status: "closed",
		closedAt: e
	};
}), He = F.object({ items: F.array(Ve) }), Ue = ({ domainUid: e, canRead: t = !0 }) => {
	let { isLoading: n, error: r, model: i, mutate: a } = K({
		api: { path: t ? `/domains/${e}/support_account_reasons` : null },
		schema: He
	});
	return t ? n ? {
		status: "loading",
		mutate: a
	} : r ? {
		status: "error",
		error: r,
		mutate: a
	} : {
		status: "loaded",
		reasons: i.items,
		mutate: a
	} : {
		status: "unauthorized",
		mutate: a
	};
}, Q = F.object({
	approver: F.string(),
	approvedOn: m,
	reason: F.string()
}), We = F.discriminatedUnion("type", [F.object({
	type: F.literal("temporary"),
	providerUser: _,
	expiresAt: m,
	issuedByEmail: F.string(),
	supportAccountReasonUid: F.string(),
	customerApproval: Q
}), F.object({
	type: F.literal("legacy"),
	providerUser: _
})]), Ge = F.object({ items: F.array(We) }), Ke = ({ domainUid: e, canRead: t = !0 }) => {
	let { isLoading: n, error: r, model: i, mutate: a } = K({
		api: { path: t ? `/domains/${e}/support_accounts` : null },
		schema: Ge
	});
	return t ? n ? {
		status: "loading",
		mutate: a
	} : r ? {
		status: "error",
		error: r,
		mutate: a
	} : {
		status: "loaded",
		supportAccounts: i.items,
		mutate: a
	} : {
		status: "unauthorized",
		mutate: a
	};
}, qe = ({ domainUid: e }) => {
	let { isLoading: t, error: n, model: r, mutate: i } = K({
		api: { path: `/domains/${e}/takken_license` },
		schema: a
	});
	return t ? {
		isLoading: t,
		error: null,
		domainTakkenLicense: null,
		mutate: i
	} : n ? {
		isLoading: !1,
		error: n,
		domainTakkenLicense: null,
		mutate: i
	} : {
		isLoading: !1,
		error: null,
		domainTakkenLicense: r,
		mutate: i
	};
}, Je = (e) => {
	let { domainUid: t } = e, n = X({
		api: { path: `/domains/${t}/users/authentication_methods` },
		schema: te,
		...e
	});
	return n.isLoading || n.error, {
		...n,
		authenticationMethods: n.models
	};
}, Ye = (e) => {
	let { domainUid: t } = e, n = X({
		api: { path: `/domains/${t}/users` },
		schema: D,
		...e
	});
	return n.isLoading || n.error, {
		...n,
		users: n.models
	};
}, Xe = (e) => {
	let { collaboratorTeamUid: t } = e, n = X({
		api: { path: `/collaborator_teams/${t}/members` },
		schema: i,
		...e
	});
	return n.isLoading || n.error, {
		...n,
		members: n.models
	};
}, Ze = (e) => {
	let { collaboratorTeamUid: t } = e, n = X({
		api: { path: `/collaborator_teams/${t}/invitations` },
		schema: r,
		...e
	});
	return n.isLoading || n.error, {
		...n,
		invitations: n.models
	};
}, Qe = ({ api: { path: e }, schema: t, config: n }) => {
	let { audience: r, baseUrl: i, customHeaders: a } = W(), o = G({
		api: {
			audience: r,
			baseUrl: i,
			path: e,
			customHeaders: a
		},
		schema: t,
		config: n
	});
	return j(() => o, [o]);
}, $ = 1024, $e = (e) => {
	let { isLoading: t, error: n, model: r } = Qe({
		api: { path: e == null ? null : `/directory/1.0/domain/${e}/usage` },
		schema: o
	});
	return { usageInfoList: j(() => t || n != null ? [] : [{
		typeName: "賃貸物件登録情報",
		usage: r.rent_bukken_usage,
		usageMax: r.rent_bukken_limit,
		unit: "件"
	}, {
		typeName: "ファイル登録状況",
		usage: r.file_usage == null ? null : Math.floor(r.file_usage / $ / $),
		usageMax: r.file_limit == null ? null : Math.floor(r.file_limit / $ / $),
		unit: "MB"
	}], [
		r,
		n,
		t
	]) };
}, et = ({ planUid: e, config: t }) => {
	let { isLoading: n, error: r, model: i, mutate: a } = K({
		api: { path: `/plans/${e}` },
		schema: h,
		config: t
	});
	return n ? {
		isLoading: n,
		error: null,
		plan: null,
		mutate: a
	} : r ? {
		isLoading: !1,
		error: r,
		plan: null,
		mutate: a
	} : {
		isLoading: !1,
		error: null,
		plan: i,
		mutate: a
	};
}, tt = (e) => {
	let t = X({
		api: { path: "/policies" },
		schema: re,
		...e
	});
	return t.isLoading || t.error, {
		...t,
		policies: t.models
	};
}, nt = ({ providerUserUid: e, enabled: t, config: n }) => {
	let { isLoading: r, error: i, model: a, mutate: o } = K({
		api: { path: t ? `/provider_users/${encodeURIComponent(e)}/authentication_methods` : null },
		schema: ie,
		config: n
	});
	return r ? {
		isLoading: r,
		error: null,
		authenticationMethods: null,
		mutate: o
	} : i ? {
		isLoading: !1,
		error: i,
		authenticationMethods: null,
		mutate: o
	} : {
		isLoading: !1,
		error: null,
		authenticationMethods: a,
		mutate: o
	};
}, rt = (e) => {
	let { providerUserUid: t } = e, n = X({
		api: { path: `/provider_users/${t}/member_applicants` },
		schema: l,
		...e
	});
	return n.isLoading || n.error, {
		...n,
		memberApplicants: n.models
	};
}, it = F.object({ items: F.array(y) }), at = ({ providerUserUid: e }) => {
	let { isLoading: t, error: n, model: r } = K({
		api: { path: `/provider_users/${e}/lockouts` },
		schema: it
	});
	return t ? {
		isLoading: t,
		error: null,
		lockouts: null
	} : n ? {
		isLoading: !1,
		error: n,
		lockouts: null
	} : {
		isLoading: !1,
		error: null,
		lockouts: r.items
	};
}, ot = F.object({ sources: v }), st = ({ providerUserUid: e, canRead: t = !0 }) => {
	let { isLoading: n, error: r, model: i, mutate: a } = K({
		api: { path: t ? `/provider_users/${e}/blocks` : null },
		schema: ot
	});
	return t ? n ? {
		status: "loading",
		mutate: a
	} : r ? {
		status: "error",
		error: r,
		mutate: a
	} : {
		status: "loaded",
		sources: i.sources,
		mutate: a
	} : {
		status: "unauthorized",
		mutate: a
	};
}, ct = (e) => e.emails == null ? "" : `&emails=${e.emails.map(encodeURIComponent).join(",")}`, lt = (e) => {
	let t = X({
		api: {
			path: "/provider_users",
			query: ct(e)
		},
		schema: _,
		...e
	});
	return t.isLoading || t.error, {
		...t,
		providerUsers: t.models
	};
}, ut = F.object({
	domain: F.object({
		domainUid: F.string(),
		name: F.string()
	}),
	providerUser: _,
	expiresAt: m,
	issuedByEmail: F.string(),
	supportAccountReasonUid: F.string(),
	customerApproval: Q
}), dt = F.object({
	startIndex: F.number(),
	itemsPerPage: F.number(),
	totalCounts: F.number(),
	items: F.array(ut)
}), ft = F.enum(["self", "all"]), pt = ({ scope: e, startIndex: t, itemsPerPage: n, canRead: r = !0 }) => {
	let { isLoading: i, error: a, model: o, mutate: s } = K({
		api: { path: r ? `/support_accounts?scope=${e}&startIndex=${t}&itemsPerPage=${n}` : null },
		schema: dt
	});
	return r ? i ? {
		status: "loading",
		mutate: s
	} : a ? {
		status: "error",
		error: a,
		mutate: s
	} : {
		status: "loaded",
		supportAccounts: o.items,
		totalCounts: o.totalCounts,
		mutate: s
	} : {
		status: "unauthorized",
		mutate: s
	};
}, mt = ({ userUid: e }) => {
	let { isLoading: t, error: n, model: r, mutate: i } = K({
		api: { path: `/users/${e}` },
		schema: D
	});
	return t ? {
		isLoading: t,
		error: null,
		user: null,
		mutate: i
	} : n ? {
		isLoading: !1,
		error: n,
		user: null,
		mutate: i
	} : {
		isLoading: !1,
		error: null,
		user: r,
		mutate: i
	};
}, ht = ({ domainUid: e, config: t }) => {
	let { isLoading: n, error: r, model: i, mutate: a } = K({
		api: { path: `/domains/${e}/mfa_state` },
		schema: ee,
		config: t
	});
	return n ? {
		isLoading: n,
		error: null,
		domainMfaState: null,
		mutate: a,
		enableMfa: !1,
		enforcedMfa: !1,
		enableTotp: !1,
		enablePasskey: !1
	} : r ? {
		isLoading: !1,
		error: r,
		domainMfaState: null,
		mutate: a,
		enableMfa: !1,
		enforcedMfa: !1,
		enableTotp: !1,
		enablePasskey: !1
	} : {
		isLoading: !1,
		error: null,
		domainMfaState: i,
		mutate: a,
		enableMfa: i.enableMfa,
		enforcedMfa: i.enforcedMfa,
		enableTotp: i.enableTotp,
		enablePasskey: i.enablePasskey
	};
}, gt = (e, t) => new URLSearchParams({
	from: e.toISOString(),
	to: t.toISOString()
}), _t = ({ filter: e, order: t, startIndex: n, itemsPerPage: r }) => {
	let i = gt(e.from, e.to), a = {
		providerUserUids: e.providerUserUids,
		organizationUids: e.organizationUids,
		operations: e.operations,
		ips: e.ips,
		ipPrefixes: e.ipPrefixes
	};
	return Object.entries(a).forEach(([e, t]) => {
		t.length > 0 && i.set(e, t.join(","));
	}), i.set("order", t), i.set("startIndex", String(n)), i.set("itemsPerPage", String(r)), i;
}, vt = ({ domainUid: e, query: t, config: n }) => K({
	api: { path: t === null ? null : `/domains/${e}/operation_histories?${_t(t).toString()}` },
	schema: f,
	config: n
}), yt = ({ domainUid: e, query: t, config: n }) => K({
	api: { path: t === null ? null : `/domains/${e}/operation_history_facets?${gt(t.from, t.to).toString()}` },
	schema: d,
	config: n
}), bt = ({ domainUid: e, query: t, config: n }) => K({
	api: { path: t === null ? null : `/domains/${e}/operation_history_settings` },
	schema: p,
	config: n
}), xt = F.object({ items: F.array(ae) }), St = ({ customerId: e }) => {
	let { isLoading: t, error: n, model: r } = K({
		api: { path: `/customers/${e}/subscriptions?includeChildren=true` },
		schema: xt
	});
	return t ? {
		isLoading: t,
		error: null,
		subscriptions: null
	} : n ? {
		isLoading: !1,
		error: n,
		subscriptions: null
	} : {
		isLoading: !1,
		error: null,
		subscriptions: r.items
	};
}, Ct = ({ customerId: e }) => {
	let { isLoading: t, error: n, model: r } = K({
		api: { path: `/customers/${e}` },
		schema: x
	});
	return t ? {
		isLoading: t,
		error: null,
		customer: null
	} : n ? {
		isLoading: !1,
		error: n,
		customer: null
	} : {
		isLoading: !1,
		error: null,
		customer: r
	};
}, wt = ({ customerId: e }) => {
	let { isLoading: t, error: n, model: r } = K({
		api: { path: `/admin/customers/${e}/profile` },
		schema: b
	});
	return t ? {
		isLoading: t,
		error: null,
		profile: null
	} : n ? {
		isLoading: !1,
		error: n,
		profile: null
	} : {
		isLoading: !1,
		error: null,
		profile: r
	};
}, Tt = ({ customerId: e }) => {
	let { isLoading: t, error: n, model: r } = K({
		api: { path: e == null ? null : `/customers/${e}/contracts` },
		schema: S,
		config: {
			revalidateOnFocus: !1,
			revalidateOnReconnect: !1
		}
	});
	return e == null || t ? {
		isLoading: !0,
		error: null,
		contracts: null
	} : n ? {
		isLoading: !1,
		error: n,
		contracts: null
	} : {
		isLoading: !1,
		error: null,
		contracts: r
	};
}, Et = ({ customerId: e }) => {
	let { isLoading: t, error: n, model: r } = K({
		api: { path: `/customers/${e}/profile` },
		schema: C
	});
	return t ? {
		isLoading: t,
		error: null,
		profile: null
	} : n ? {
		isLoading: !1,
		error: n,
		profile: null
	} : {
		isLoading: !1,
		error: null,
		profile: r
	};
}, Dt = ({ providerUserUid: e }) => {
	let { isLoading: t, error: n, model: r, mutate: i } = K({
		api: { path: `/provider_users/${e}` },
		schema: _
	});
	return t ? {
		isLoading: t,
		error: null,
		providerUser: null,
		mutate: i
	} : n ? {
		isLoading: !1,
		error: n,
		providerUser: null,
		mutate: i
	} : {
		isLoading: !1,
		error: null,
		providerUser: r,
		mutate: i
	};
}, Ot = (e) => {
	let t = [];
	return e.domainUids != null && t.push("domainUids=" + e.domainUids.join(",")), t.length === 0 ? "" : `&${t.join("&")}`;
}, kt = (e) => {
	let t = X({
		api: {
			path: "/domains",
			query: Ot(e)
		},
		schema: w,
		...e
	});
	return t.isLoading || t.error, {
		...t,
		domains: t.models
	};
}, At = (e) => {
	let t = [];
	return e.domainUids != null && t.push("domainUids=" + e.domainUids.join(",")), e.organizationUids != null && t.push("organizationUids=" + e.organizationUids.join(",")), t.length === 0 ? "" : `&${t.join("&")}`;
}, jt = (e) => {
	let t = X({
		api: {
			path: "/organizations",
			query: At(e)
		},
		schema: T,
		...e
	});
	return t.isLoading || t.error, {
		...t,
		organizations: t.models
	};
}, Mt = (e) => {
	let t = [];
	return e.domainUids != null && t.push("domainUids=" + e.domainUids.join(",")), t.length === 0 ? "" : `&${t.join("&")}`;
}, Nt = (e) => {
	let t = X({
		api: {
			path: "/roles",
			query: Mt(e)
		},
		schema: E,
		...e
	});
	return t.isLoading || t.error, {
		...t,
		roles: t.models
	};
}, Pt = ({ initialOrderBy: e }) => {
	let [t, n] = N("desc"), [r, i] = N(e);
	return {
		order: t,
		orderBy: r,
		onRequestSort: A((e) => {
			n(r === e && t === "desc" ? "asc" : "desc"), i(e);
		}, [
			r,
			t,
			n,
			i
		])
	};
};
//#endregion
export { R as ApiClient, Q as CustomerApproval, Oe as DomainMemo, be as EsaApiProvider, I as HttpError, xe as OneApiProvider, We as SupportAccount, ut as SupportAccountListItem, Ie as SupportAccountProhibition, Ve as SupportAccountReason, ft as SupportAccountScope, _e as textFilter, Z as toDomainPlansQuery, _t as toOperationHistoryPageParams, ct as toProviderUsersQuery, wt as useAdminCustomerProfile, z as useApiClient, Ze as useCollaboratorTeamInvitations, Xe as useCollaboratorTeamMembers, Ct as useCustomer, Tt as useCustomerContracts, Et as useCustomerProfile, St as useCustomerSubscriptions, fe as useDialog, q as useDomain, De as useDomainInvitations, je as useDomainMemberApplicants, Ae as useDomainMemo, ht as useDomainMfaState, vt as useDomainOperationHistories, yt as useDomainOperationHistoryFacets, bt as useDomainOperationHistorySettings, Me as useDomainOrganizations, Pe as useDomainPlanSummaries, Ne as useDomainPlans, Fe as useDomainRoles, Re as useDomainSupportAccountProhibition, Ue as useDomainSupportAccountReasons, Ke as useDomainSupportAccounts, qe as useDomainTakkenLicense, Je as useDomainUserAuthenticationMethods, Ye as useDomainUsers, kt as useDomains, de as useEffectOnce, pe as useEntityDialog, H as useEsaApiContext, we as useFcLicense, me as useFilter, he as useGlobalFilter, ve as useMenu, G as useModel, Y as useModels, W as useOneApiContext, $e as useOneApiUsage, jt as useOrganizations, et as usePlan, tt as usePolicies, Dt as useProviderUser, nt as useProviderUserAuthenticationMethods, st as useProviderUserBlock, at as useProviderUserLockouts, rt as useProviderUserMemberApplicants, lt as useProviderUsers, Nt as useRoles, ce as useSWR, Pt as useSort, pt as useSupportAccounts, mt as useUser };

//# sourceMappingURL=esa-hooks.mjs.map